import { Component, Event, EventEmitter, h, Host, Listen, Prop } from '@stencil/core';
import { If } from '@utils/If';

@Component({
  tag: 'sub-menu-item',
  styleUrl: 'sub-menu-item.scss',
  shadow: true
})
export class SubMenuItem {
  @Prop() item: any = {};
  @Prop() isActive: boolean = false;
  @Prop() logoUrl: string;
  @Prop() submenuType: 'primary' | 'secondary' = 'secondary';

  // emit a clear, single-responsibility event
  @Event({ eventName: 'menuSelect', bubbles: true, composed: true })
  menuSelect!: EventEmitter<any>;

  private handleActivate = (event: MouseEvent | KeyboardEvent) => {
    event.preventDefault();
    event.stopPropagation();
    this.menuSelect.emit(this.item);
  };

  // optional: keyboard a11y (Enter/Space to activate)
  @Listen('keydown')
  onKeydown(ev: KeyboardEvent) {
    if (ev.key === 'Enter' || ev.key === ' ') {
      this.handleActivate(ev);
    }
  }

  render() {
    const href = this.item?.redirectUrl || '#';
    return (
      <Host>
        <a
          href={href}
          onClick={this.handleActivate}
          class={`flex cursor-pointer item-active items-center gap-3 py-2 ${this.submenuType === 'secondary' ? 'rounded-lg px-4' : 'rounded-4xl pl-3 pr-4'
            }`}
          aria-current={this.isActive ? 'page' : undefined}
          role="link"
          tabindex={0}
        >
          <If
            condition={this.submenuType !== 'secondary' && !!this.logoUrl}
            children={
              <div
                style={{ backgroundColor: this.item.background }}
                class="rounded-full overflow-hidden w-10 h-10 flex items-center justify-center"
              >
                <img alt="" src={this.logoUrl} />
              </div>
            }
          />
          <div>
            <div class="flex gap-2 items-center">
              <h4 class={`${this.submenuType === 'secondary' ? 'text-sm font-normal' : 'text-sm font-semibold'}`}>
                {this.item.title}
              </h4>
              <If
                condition={this.item?.badge}
                children={<header-badge class="leading-none" blink={this.item?.blink}>{this.item?.badge?.title}</header-badge>}
              />
            </div>
            <h5 class="text-sm text-gray-300">{this.item.subTitle}</h5>
          </div>
        </a>
      </Host>
    );
  }
}
